import { IGeography, IAccommodation } from '../../store/actions/sales-configuration';

function distinct(values: string[]): string[] {
  return [...new Set(values)];
}

export function getFilteredRegions(geographies: IGeography[], selectedCountryCodes: string[]): string[] {
  const matching =
    selectedCountryCodes.length === 0
      ? geographies
      : geographies.filter((geography) => selectedCountryCodes.includes(geography.countryCode));

  return distinct(matching.map((geography) => geography.regionCode));
}

export function getFilteredDestinations(
  geographies: IGeography[],
  selectedCountryCodes: string[],
  selectedRegionCodes: string[]
): string[] {
  const matching = geographies.filter((geography) => {
    const matchesCountry = selectedCountryCodes.length === 0 || selectedCountryCodes.includes(geography.countryCode);
    const matchesRegion = selectedRegionCodes.length === 0 || selectedRegionCodes.includes(geography.regionCode);
    return matchesCountry && matchesRegion;
  });

  return distinct(matching.map((geography) => geography.destinationCode));
}

export function getFilteredAccommodations(
  accommodations: IAccommodation[],
  selectedCountryCodes: string[],
  selectedRegionCodes: string[],
  selectedDestinationCodes: string[]
): string[] {
  const matching = accommodations.filter((accommodation) => {
    const matchesCountry =
      selectedCountryCodes.length === 0 ||
      (accommodation.countryCode !== null && selectedCountryCodes.includes(accommodation.countryCode));
    const matchesRegion =
      selectedRegionCodes.length === 0 ||
      (accommodation.regionCode !== null && selectedRegionCodes.includes(accommodation.regionCode));
    const matchesDestination =
      selectedDestinationCodes.length === 0 ||
      (accommodation.destinationCode !== null && selectedDestinationCodes.includes(accommodation.destinationCode));
    return matchesCountry && matchesRegion && matchesDestination;
  });

  return distinct(matching.map((accommodation) => accommodation.code));
}
